var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "list" }, [
        _c(
          "div",
          { staticClass: "list-search" },
          [
            _c("el-input", {
              attrs: {
                placeholder: _vm.$t("system::rbac::搜索角色名称"),
                clearable: "",
              },
              on: {
                blur: function ($event) {
                  return _vm.getRoleList()
                },
                clear: function ($event) {
                  return _vm.getRoleList()
                },
              },
              model: {
                value: _vm.searchRole,
                callback: function ($$v) {
                  _vm.searchRole = $$v
                },
                expression: "searchRole",
              },
            }),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "8px" },
                attrs: { type: "primary" },
                on: { click: _vm.toAdd },
              },
              [_vm._v(" " + _vm._s(_vm.$t("system::rbac::新增角色")) + " ")]
            ),
          ],
          1
        ),
        _c(
          "ul",
          { staticClass: "role-list" },
          _vm._l(_vm.roleList, function (item) {
            return _c(
              "li",
              {
                key: item.roleId,
                staticClass: "list-item",
                class: { active: _vm.activeRole.roleId === item.roleId },
                on: {
                  click: function ($event) {
                    return _vm.changeRole(item)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(item.roleName)),
                    ]),
                    _c("span", { staticClass: "num" }, [
                      _vm._v("（" + _vm._s(item.usersNum) + "）"),
                    ]),
                  ]
                ),
                _c("div", [
                  _c("i", {
                    staticClass: "el-icon-edit",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.edit(item)
                      },
                    },
                  }),
                  _c("i", {
                    staticClass: "el-icon-delete-solid",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.remove(item)
                      },
                    },
                  }),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "wrap" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
            },
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: _vm.activeTab === "role" ? "primary" : "" },
                    on: {
                      click: function ($event) {
                        return _vm.changeType("role")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("system::rbac::员工角色分配")) + " "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: _vm.activeTab === "auth" ? "primary" : "",
                      disabled: !_vm.roleList.length,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeType("auth")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("system::rbac::角色权限设置")) + " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "el-input",
                  {
                    staticStyle: { width: "200px", "margin-right": "10px" },
                    attrs: {
                      placeholder: _vm.$t("system::rbac::搜索姓名或手机号码"),
                    },
                    model: {
                      value: _vm.searchValue,
                      callback: function ($$v) {
                        _vm.searchValue = $$v
                      },
                      expression: "searchValue",
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        slot: "append",
                        icon: "el-icon-search",
                        type: "primary",
                      },
                      on: { click: _vm.searchForRole },
                      slot: "append",
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-plus",
                      disabled:
                        !_vm.activeRole.roleId || _vm.activeTab !== "role",
                    },
                    on: {
                      click: function ($event) {
                        _vm.$refs.role.isShowAdd = true
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("system::rbac::添加员工")) + " ")]
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "wrap-content" },
          [
            _c(_vm.activeTab, {
              ref: _vm.activeTab,
              tag: "component",
              attrs: { role: _vm.activeRole },
              on: {
                refresh: function ($event) {
                  return _vm.getRoleList(true)
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c("AddRole", {
        attrs: { drawRow: _vm.drawRow },
        on: {
          refresh: function ($event) {
            return _vm.getRoleList(true)
          },
        },
        model: {
          value: _vm.isShowAdd,
          callback: function ($$v) {
            _vm.isShowAdd = $$v
          },
          expression: "isShowAdd",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }